import React from "react";

import { Particles } from "react-particles-js";
import particlesConfig from "./particles-config";

import Page from "./Page";

function App() {
  return (
    <Page>
      <Particles className='particles' params={particlesConfig} />
      <div className='container'>
        <div>
          <img src={`${process.env.PUBLIC_URL}/nodeschool.png`} alt='' />
        </div>
        <div style={{ textAlign: "center" }}>
          <h1 style={{ color: "white" }}>
            <span role='img' aria-label='construction sign'>
              🚧
            </span>
            NodeSchool Madison is currently undergoing renovations!
            <span role='img' aria-label='construction sign'>
              🚧
            </span>
          </h1>
          <p style={{ color: "white" }}>
            Feel free to follow
            <a href='https://twitter.com/NodeschoolMSN'>@nodeschoolmsn</a> on
            Twitter for updates
            <span role='img' aria-label='party popper'>
              🎉
            </span>
          </p>
        </div>
      </div>
    </Page>
  );
}

export default App;
